import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/fee/feepageHero";
import FeeTables from "../components/fee/feeTables";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Dental Prices in Ilkley, West Yorkshire | Regent Dental</title>
        <meta
          name="description"
          content="Discover clear and transparent dental fees in West Yorkshire at Regent Dental. Check our prices for check-ups, hygiene services, cosmetic treatments, and more."
        />
        <link
          rel="canonical"
          href="https://www.regent-dental.co.uk/dental-fees"
        />
      </Helmet>
      <Navbar />
      <Header />
      <FeeTables />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
